<template>
  <v-row no-gutters>
    <v-col>
      <v-form ref="anomalyDetectionForm" v-model="computedIsValid">
        <v-row no-gutters v-for="(range, idx) of computedValue" :key="idx" align="start">
          <v-col cols="1" class="pt-2">
            <data-input :data-type="{ name: 'checkbox' }" v-model="range.value" @input="filter" />
          </v-col>
          <v-col cols="4" class="text-left text-body-2 pt-3">
            {{ `${idx + 1} ${$i18n.t('sidebar.range').toLowerCase()}:` }}
          </v-col>
          <v-col cols="auto" class="pr-5">
            <data-input v-bind="colorInput" v-model="range.color" />
          </v-col>
          <v-col cols="5">
            <data-input v-bind="sizeInput" v-model="range.size" />
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import DataInput from '@/components/DataInput';
export default {
  name: 'SidebarRangesStyleRows',
  components: {
    DataInput,
  },
  props: {
    filterAttribute: {
      type: String,
    },
    isValid: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    computedIsValid: {
      get() {
        return this.isValid;
      },
      set(nV) {
        this.$emit('update:isValid', nV);
      },
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    colorInput() {
      return {
        dataType: { name: 'color' },
      };
    },
    filterLeft() {
      return {
        '!OR': [
          {
            $LESS_OR_EQUAL: {
              [this.filterAttribute]: { value: this.value[0].maxValue },
            },
          },
          {
            $EQUAL: {
              [this.filterAttribute]: { value: null },
            },
          },
        ],
      };
    },
    filterRight() {
      return {
        $GREATER_THAN: {
          [this.filterAttribute]: { value: this.value[1].minValue },
        },
      };
    },
    sizeInput() {
      return {
        dataType: { name: 'integer' },
        label: this.$i18n.t('dialog.style.pointSize'),
        rules: this.sizeRules,
      };
    },
    sizeRules() {
      return [
        v => v <= 40 || this.$i18n.t('rules.maxValue', { value: 40 }),
        v => v >= 1 || this.$i18n.t('rules.minValue', { value: 1 }),
      ];
    },
  },
  methods: {
    filter() {
      this.$root.$emit('setAdditionalFilters', this.getFilter());
    },
    getFilter() {
      const leftValue = this.computedValue[0].value;
      const rightValue = this.computedValue[1].value;
      if (leftValue && rightValue) {
        return {
          '!OR': [this.filterLeft, this.filterRight],
        };
      } else if (leftValue || rightValue) {
        return leftValue ? this.filterLeft : this.filterRight;
      } else {
        return {
          $IN: {
            [this.filterAttribute]: { value: [] },
          },
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-input--checkbox {
    padding-top: 0;
    margin-top: 0;
  }
}
</style>
